<div class="news-block">
  <div class="slider">
    <mtg-news-slider [sport]="league.sport"></mtg-news-slider>
  </div>
  <div class="side">
    <mtg-banners-slider class="side-slider" [location]="bannerLocations.slider"></mtg-banners-slider>
    <mtg-news-list></mtg-news-list>
  </div>
</div>

<mtg-partners-list></mtg-partners-list>

<ng-container *ngFor="let court of courts">
  <mtg-league-games-slider
     *ngIf="court.activeGamesCount > 0"
    [court]="court"
    [leagueId]="league.id"
  ></mtg-league-games-slider>
</ng-container>

<mtg-league-live></mtg-league-live>

<ng-container *ngFor="let tournament of tournaments">
  <mtg-tournament-widget
    *ngIf="tournament.settings.type !== tournamentTypes.fiba"
    [tournament]="tournament"
  ></mtg-tournament-widget>
  <mtg-tournament-stage-widget
    *ngIf="tournament.settings.type === tournamentTypes.fiba"
    [tournament]="tournament"
  ></mtg-tournament-stage-widget>
</ng-container>

<mtg-banners-slider class="long-slider" [location]="bannerLocations.central"></mtg-banners-slider>

<mtg-league-video></mtg-league-video>
<mtg-league-photos [leagueId]="league.id"></mtg-league-photos>
<mtg-league-about-block></mtg-league-about-block>
